var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLockOpen = function SvgLockOpen(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 IconLeft"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 13.1833C9.825 13.1833 10.5 12.5083 10.5 11.6833C10.5 10.8583 9.825 10.1833 9 10.1833C8.175 10.1833 7.5 10.8583 7.5 11.6833C7.5 12.5083 8.175 13.1833 9 13.1833ZM13.5 6.43329H12.75V4.93329C12.75 2.86329 11.07 1.18329 9 1.18329C6.93 1.18329 5.25 2.86329 5.25 4.93329H6.675C6.675 3.65079 7.7175 2.60829 9 2.60829C10.2825 2.60829 11.325 3.65079 11.325 4.93329V6.43329H4.5C3.675 6.43329 3 7.10829 3 7.93329V15.4333C3 16.2583 3.675 16.9333 4.5 16.9333H13.5C14.325 16.9333 15 16.2583 15 15.4333V7.93329C15 7.10829 14.325 6.43329 13.5 6.43329ZM13.5 15.4333H4.5V7.93329H13.5V15.4333Z",
    fill: "#2E2E2E"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLockOpen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "LockOpen.6002998e4ef35a849091f4ff6310edfe.svg";